export default __webpack_public_path__ + "static/media/1.ddb6eb63.png";